<template>
  <Game />
</template>

<script>
import Game from '@/components/Game'
export default {
  components: { Game }
}
</script>

<style lang="scss">
@font-face {
    font-family: "Jumbo";
    src: url(./fonts/JumboSale-Trial.ttf);
}

@font-face {
    font-family: "Manga";
    src: url(./fonts/mangat.ttf);
}

@font-face {
    font-family: "Grobold";
    src: url(./fonts/grobold.ttf);
}

@font-face {
    font-family: "Inter";
    src: url(./fonts/inter.ttf);
}

body {
  margin: 0;
}

#app{
  width: 100vw;
  height: 100vh;
  margin: 0;
}
</style>
